import React, { useEffect, useState } from "react";
import API from "../services/api";

function Users() {

const [users,setUsers] = useState([]);

useEffect(()=>{
fetchUsers();
},[]);

const fetchUsers = async ()=>{

try{

const res = await API.get("/users");

setUsers(res.data);

}catch(err){

console.log(err);

}

};


const deleteUser = async (id)=>{

if(!window.confirm("Delete this user?")) return;

try{

await API.delete(`/users/${id}`);

fetchUsers();

}catch(err){

console.log(err);

}

};


const toggleStatus = async (id,currentStatus)=>{

try{

await API.put(`/users/status/${id}`,{
is_active: !currentStatus
});

fetchUsers();

}catch(err){

console.log(err);

}

};


return(

<div style={{padding:"40px"}}>

<h2>Employees List</h2>

<button onClick={fetchUsers} style={{marginBottom:"20px"}}>
Refresh
</button>

<table border="1" cellPadding="10" width="100%">

<thead>

<tr>

<th>ID</th>
<th>Name</th>
<th>Email</th>
<th>Role</th>
<th>Status</th>
<th>Action</th>

</tr>

</thead>

<tbody>

{users.map((u)=>(

<tr key={u.id}>

<td>{u.id}</td>

<td>{u.name}</td>

<td>{u.email}</td>

<td>{u.role_name}</td>

<td>

<button
onClick={()=>toggleStatus(u.id,u.is_active)}
>

{u.is_active ? "Active" : "Inactive"}

</button>

</td>

<td>

<button
onClick={()=>deleteUser(u.id)}
style={{color:"red"}}
>

Delete

</button>

</td>

</tr>

))}

</tbody>

</table>

</div>

);

}

export default Users;